import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoLight from "../../assets/images/logo.png";
import logoDark from "../../assets/images/logo.png";
import ForgotPasswordForm from "../../components/ForgotPasswordForm";

const ForgotPasswordPage = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <div className="login-page">
      <div className="left-panel">
        <p className="left-logo">
          <img
            src={isDarkMode ? logoDark : logoLight}
            alt="healthscope.ai"
            className="d-inline-block align-top"
          />
        </p>
      </div>

      <div className="right-panel">
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
